import React, { useState } from "react";
import {
  InsightDurationDaily,
  InsightDurationMonthly,
  InsightDurationWeekly,
} from "../../../libs";
import { SuperAdminDashboardItemThreeDotsIcon } from "../../../libs/SVGIcons";

export const SuperAdminNumberItemElement = ({
  icon,
  numberItemTitle,
  numberTwoItemTitle = "",
  number,
  numberTwo = "",
  currencySymbol,
  currencyTwoSymbol = "",
  isPercentage = false,
  isTwoPercentage = false,
  onDurationClick,
  togglePopup,
  showPopUpOnClick = false,
  secondaryInformationText = "-",
  showThreeDotsClick = true,
  lang,
  hideOnOtherThanMobile = false,
  hideOnMobile = false,
}) => {
  const [state, setState] = useState({
    showSubMenu: false,
  });
  let numberItemTitleStyle = {
    color: "#199B8B",
    marginLeft: "0.71rem",
    fontSize: "0.9rem",
    userSelect: "none",
  };
  let currencySymbolStyle = { marginLeft: "0.4375rem", userSelect: "none" };
  if (lang === "ar") {
    currencySymbolStyle = { marginRight: "0.4375rem", userSelect: "none" };
    numberItemTitleStyle = {
      color: "#199B8B",
      marginRight: "0.71rem",
      userSelect: "none",
    };
  }
  return (
    <div
      className={
        "col-6 col-md-4 col-lg-2 col-xl-2 number-item-button " +
        (hideOnOtherThanMobile ? " hide-on-other-than-mobile " : "") +
        (hideOnMobile ? " hide-on-mobile " : "")
      }
    >
      <div
        className="clickable"
        style={{
          position: "relative",
          paddingTop: "1.25rem",
          paddingBottom: "1.25rem",
          paddingRight: "1.1rem",
          paddingLeft: "1.1rem",
          backgroundColor: "white",
          borderRadius: "20px",
        }}
      >
        {showThreeDotsClick && (
          <div
            style={{
              position: "absolute",
              right: "10px",
              top: "5px",
            }}
            onClick={() => {
              if (showPopUpOnClick && togglePopup) togglePopup();
              else {
                setState({
                  ...state,
                  showSubMenu: !state.showSubMenu,
                });
              }
            }}
          >
            <SuperAdminDashboardItemThreeDotsIcon />
          </div>
        )}
        {state.showSubMenu && (
          <div className="three-dot-menu-container">
            <ul className="three-dot-menu">
              <li
                className="inter"
                onClick={async () => {
                  setState({ ...state, showSubMenu: false });
                  if (onDurationClick) onDurationClick(InsightDurationDaily);
                }}
              >
                {window.sys_app_translate("Today", lang)}
              </li>
              <li
                className="inter"
                onClick={() => {
                  setState({ ...state, showSubMenu: false });
                  if (onDurationClick) onDurationClick(InsightDurationWeekly);
                }}
              >
                {window.sys_app_translate("This Week", lang)}
              </li>
              <li
                className="inter"
                onClick={() => {
                  setState({ ...state, showSubMenu: false });
                  if (onDurationClick) onDurationClick(InsightDurationMonthly);
                }}
              >
                {window.sys_app_translate("This Month", lang)}
              </li>
            </ul>
          </div>
        )}
        <div className="container">
          <div className="row">
            <div className="col-5 d-flex align-items-center justify-content-end">
              <span className="icon">{icon}</span>
            </div>
            <div className="col-7 px-0">
              <div className="container">
                <div className="row">
                  <div className="col-12 px-0">
                    {numberTwoItemTitle ? (
                      <div className="d-flex flex-column gap-2 align-items-start">
                        <div className="d-flex align-items-center justify-content-between">
                          <span
                            className="title inter-semi-bold mx-0"
                            style={numberItemTitleStyle}
                          >
                            {numberItemTitle}
                          </span>
                          <span
                            className="number inter-bold font-size-1 ms-2"
                            style={{ userSelect: "none" }}
                          >
                            {number}
                          </span>
                          {isPercentage ? (
                            <span className="inter-bold font-size-1 mx-0">
                              %
                            </span>
                          ) : (
                            <span
                              className="currency-symbol"
                              style={currencySymbolStyle}
                            >
                              {currencySymbol}
                            </span>
                          )}
                        </div>
                        <div className="d-flex align-items-center justify-content-between">
                          <span
                            className="title inter-semi-bold mx-0"
                            style={numberItemTitleStyle}
                          >
                            {numberTwoItemTitle}
                          </span>
                          <span
                            className="number inter-bold font-size-1 ms-2"
                            style={{ userSelect: "none" }}
                          >
                            {numberTwo}
                          </span>
                          {isTwoPercentage ? (
                            <span className="inter-bold font-size-1 mx-0">
                              %
                            </span>
                          ) : (
                            <span
                              className="currency-symbol"
                              style={currencySymbolStyle}
                            >
                              {currencyTwoSymbol}
                            </span>
                          )}
                        </div>
                      </div>
                    ) : (
                      <span
                        className="title inter-semi-bold mx-0"
                        style={numberItemTitleStyle}
                      >
                        {numberItemTitle}
                      </span>
                    )}
                  </div>
                </div>
                {!numberTwo && !numberTwoItemTitle && (
                  <div className="row">
                    <div className="col-12 px-0">
                      <span
                        className="number inter-bold font-size-1"
                        style={{ userSelect: "none" }}
                      >
                        {number}
                      </span>
                      {isPercentage ? (
                        <span className="inter-bold font-size-1 mx-0">%</span>
                      ) : (
                        <span
                          className="currency-symbol"
                          style={currencySymbolStyle}
                        >
                          {currencySymbol}
                        </span>
                      )}
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
          {/* <div className="row">
            <div className="container">
              <div className="row">
                <div className="col-12 text-center px-0">
                  <span
                    style={{
                      color:
                        secondaryInformationText === "-"
                          ? "#ffffff"
                          : "#000000",
                    }}
                  >
                    {secondaryInformationText}
                  </span>
                </div>
              </div>
            </div>
          </div> */}
        </div>
      </div>
    </div>
  );
};
